var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUsermenuRepots = function SvgIconUsermenuRepots(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "A0360BD9-DC03-4145-82D5-D377442D8CF4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-menu",
    transform: "translate(-21.000000, -283.000000)",
    stroke: "#90949C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-usermenu-repots",
    transform: "translate(22.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "custom-reports-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "custom-reports"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: -0.5,
    y: -0.5,
    width: 13,
    height: 17,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3.42857143 5.26600095 5.63029545 7.25922732 8.66625548 3.55555556"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.57142857,
    y1: 10.5835097,
    x2: 9.42857143,
    y2: 10.5835097,
    id: "Path-10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.57142857,
    y1: 13.3333333,
    x2: 9.42857143,
    y2: 13.3333333,
    id: "Path-10-Copy",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUsermenuRepots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-usermenu-repots.d133008d.svg";
export { ForwardRef as ReactComponent };